// メッセージボックス_OK_CANCEL用棚
import React, { useCallback } from 'react';
import { Row, Col } from 'react-bootstrap';
var Dialog = function (_a) {
    var label = _a.label, body = _a.body, ok = _a.ok, okCallback = _a.okCallback, open = _a.open;
    var handleClickOk = useCallback(function (event) {
        okCallback(event);
    }, []);
    return (React.createElement("div", { className: "dialog" },
        React.createElement("div", { className: "dialog-mask", style: { display: open ? 'block' : 'none' } }),
        React.createElement("div", { className: "dialog-section", style: { display: open ? 'block' : 'none' } },
            React.createElement("div", { className: "dialog-inner" },
                React.createElement("div", { className: "dialog-contents" },
                    React.createElement("h3", null, label),
                    React.createElement("div", { className: "dialog-body" }, body),
                    React.createElement(Row, { className: "dialog-button" },
                        React.createElement(Col, { xl: 12, lg: 12, md: 12, sm: 12, xs: 12 },
                            React.createElement("button", { className: "c-btn btn-large btn-main-color mx-auto", type: "button", onClick: handleClickOk }, ok))))))));
};
export default Dialog;
